import DkSlider from '@v4/common/components/molecules/DkSlider/DkSlider.vue';

export default DkSlider;
